module.exports = __webpack_public_path__ + "img/271695520040037.82f48318.jpg";